export default __webpack_public_path__ + "static/media/printStatus.d7f348c0.svg";